/* ============
 * Vuex Getters
 * ============
 *
 * All the getters that can be used
 * inside the store
 */

import personStore from './personStore'
import {find, forEach} from 'lodash'

export default {
  getHofTeam: (state) => (teamName) => {
    let team = null
    forEach(state.hof.all, (hofDecade) => {
      const hofTeam = find(hofDecade.teams, ['teamName', teamName])
      if (hofTeam) {
        team = hofTeam
        return false
      }
    })
    return team;
  },
  getHofAthlete: (state) => (id) => {
    let athlete = null;
    forEach(state.hof.all, (hofDecade) => {
      const hofAthlete = find(hofDecade.athletes, ['ppdbid', id])
      if (hofAthlete) {
        athlete = hofAthlete
        return false
      }
    })
    return athlete;
  },
  getPerson: (state) => (id) => {
    if (state.persons.loaded && personStore.all[id]) {
      return personStore.all[id][0]
    } else {
      return {id: null, name: null, ppdbid: null}
    }
  }
}

